<template>
<div class="chapter">
<div class="inner_page">
<div id="fm2">
<p class="half"><span>A Free Man of Color</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9780802195005_half_title.vue?2a3ce689